import { supabase } from "@/integrations/supabase/client";

export type FunnelEvent =
  | "form_view"
  | "category_selected"
  | "photo_uploaded"
  | "submit_attempt"
  | "submit_success"
  | "quick_call"
  | "quick_sms"
  | "quick_mail";

const sent = new Set<string>();

/** Loggar ett steg i reservdelsflödet (anonymt, en gång per steg och sidvisning). */
export function trackPartsFunnel(event: FunnelEvent, once = true) {
  if (typeof window === "undefined") return;
  if (once && sent.has(event)) return;
  sent.add(event);
  void (supabase.from("spare_parts_funnel" as never) as any)
    .insert({ event, page: window.location.pathname.slice(0, 200) })
    .then(() => {}, () => {});
}
